export default __webpack_public_path__ + "static/media/foundU-integration-icon.afcaa58f.webp";